import {
  FetchExternalDashboardsSettingsRequest,
  FetchExternalDashboardsSettingsSuccess,
  FetchExternalDashboardsSettingsFailure,
  UpdateExternalDashboardsSettingsRequest,
  UpdateExternalDashboardsSettingsSuccess,
  UpdateExternalDashboardsSettingsFailure,
} from './external-dashboard-settings.actions'
import { ExternalDashboardsSettingsService } from './external-dashboard-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as ExternalDashboardsSettingsTypes from './external-dashboard-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class ExternalDashboardsSettingsEffects {
  constructor(
    private actions: Actions,
    private externalDashboardsSettingsService: ExternalDashboardsSettingsService,
  ) {}

  FetchExternalDashboardsSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST,
      ),
      switchMap((action: FetchExternalDashboardsSettingsRequest) => {
        return this.externalDashboardsSettingsService
          .fetchExternalDashboardsSettings()
          .pipe(
            map((result) => {
              return new FetchExternalDashboardsSettingsSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(
                new FetchExternalDashboardsSettingsFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )

  UpdateExternalDashboardsSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST,
      ),
      switchMap((action: UpdateExternalDashboardsSettingsRequest) => {
        return this.externalDashboardsSettingsService
          .updateExternalDashboardsSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateExternalDashboardsSettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(
                new UpdateExternalDashboardsSettingsFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )
}
